import axios from '../services/request'

/* 获取班级考试通知 */
export const examList = (data = {}) => axios.get('api/teach/examList',data);

/* 试卷预览 */
export const previewExam = (data = {}) => axios.get('api/teach/previewExam',data);

/* 获取班级列表 */
export const examPlan = (data = {}) => axios.get('api/teach/examPlan',data);

/* 学生列表、成绩 */
export const student = (data = {}) => axios.get('api/teach/student',data);

/* 成绩总览 */
export const overview = (data = {}) => axios.get('api/teach/overview',data);

/* 班级延时设置 */
export const updateExamtime = (data = {}) => axios.post('api/teach/updateExamtime',data);

/* 图表数据 */
export const getChartsData = (data = {}) => axios.get('api/teach/getChartsData',data);

/* 发送补考通知 */
export const userMessage = (data = {}) => axios.post('api/teach/userMessage',data);

/* 获取学生阅读、写作题 */
export const dojob = (data = {}) => axios.get('api/teach/dojob',data);

/* 提交批改分数 */
export const correctWork = (data = {}) => axios.post('api/teach/correctWork',data);

/* 删除考试 */
export const delExam = (data = {}) => axios.get('api/teach/delExam',data);

/* 查看学生试卷 */
export const studentExam = (data = {}) => axios.get('api/teach/studentExam',data);

export const getTremGrade = (data = {}) => axios.get('api/teach/getTremGrade',data);
export default{
    examList,
    previewExam,
    examPlan,
    student,
    overview,
    updateExamtime,
    getChartsData,
    userMessage,
    dojob,
    correctWork,
    delExam,
    getTremGrade,
    studentExam
}